import { isBookPreorder } from '@fable/utils'
import { useTypedSelector } from 'hooks'
import { ClubMachineContext, clubPromoCode } from 'state/machines'
import { getParameterByName, getReferralId } from 'utils'
import differenceInDays from 'date-fns/differenceInDays'
import { User } from '@fable/types'
import { promoCodes } from '../../../constants'
import { useCallback } from 'react'

const getTestPromoCode = () => {
  const param = getParameterByName('code')
  const key = localStorage.getItem(clubPromoCode)
  const code = param || key
  return !!code && code === promoCodes.readMore ? code : null
}

const isRecentlyNewUser = (user: User) => {
  if (!user || !user?.signed_up_at) return true
  const days = differenceInDays(new Date(), new Date(user.signed_up_at))
  return days < 7
}

export const useClubBookPromo = ({
  ctx,
}: { ctx?: ClubMachineContext } = {}) => {
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const { profile } = useTypedSelector(({ user }) => user)
  const { id: referralId } = getReferralId()
  const book = ctx?.club?.current_book

  const eligibleUser = isRecentlyNewUser(profile.data)

  const eligibleClub =
    ctx?.clubType === 'free' &&
    !referralId &&
    !ctx?.invite &&
    ctx?.club?.access_type !== 'private'

  const eligibleBook =
    !book?.is_out_of_catalog &&
    book?.can_purchase &&
    !isBookPreorder(book) &&
    parseFloat(book?.price_usd) > 5

  const promoActive = !isAuthenticated && eligibleClub && eligibleBook

  const code = getTestPromoCode()

  const active = (promoActive || !!code) && eligibleUser

  const clearPromoKey = useCallback(() => {
    if (!active && !!code) {
      localStorage.removeItem(clubPromoCode)
    }
  }, [active, code])

  return {
    active,
    code,
    clearPromoKey,
  }
}
